module.exports = __webpack_public_path__ + "img/title_9.4050ddef.png";